import React from 'react';
import PropTypes from 'prop-types';
import {IconButton} from 'react-toolbox/lib/button';
import {getImagIcon} from "../../../utils/iconHelper";

function SunbitIconButton(props) {
  const {children, ...restProps} = props;

  let iconToRender = getImagIcon(restProps.icon , 'iconButton notCustomerIcon');
  restProps.icon = ''; // remove icon from lib/button

  return (
    <IconButton {...restProps}>
      {children}
      {iconToRender}
    </IconButton>
  );
}

SunbitIconButton.propTypes = {
  children: PropTypes.node,
};

export default SunbitIconButton;




// WEBPACK FOOTER //
// ./src/components/common/material/IconButton.js